import { render, staticRenderFns } from "./EmptyData.vue?vue&type=template&id=63be4fd6&scoped=true"
import script from "./EmptyData.vue?vue&type=script&lang=js"
export * from "./EmptyData.vue?vue&type=script&lang=js"
import style0 from "./EmptyData.vue?vue&type=style&index=0&id=63be4fd6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63be4fd6",
  null
  
)

export default component.exports